/* Kasutam theme — product page: gallery thumbnails + variant picker */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-product-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-section-type="main-product"]').forEach(initVariantPicker);
  });

  function initGallery(gallery) {
    var thumbs = gallery.querySelectorAll('[data-thumb]');
    var images = gallery.querySelectorAll('.product__main-image-item');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var id = thumb.getAttribute('data-media-id');
        thumbs.forEach(function (t) {
          t.classList.toggle('is-active', t === thumb);
        });
        images.forEach(function (img) {
          img.classList.toggle('is-active', img.getAttribute('data-media-id') === id);
        });
      });
    });
  }

  function showMediaById(root, mediaId) {
    if (!mediaId) return;
    var thumb = root.querySelector('[data-thumb][data-media-id="' + mediaId + '"]');
    if (thumb) thumb.click();
  }

  function initVariantPicker(root) {
    var variantsScript = root.querySelector('[data-product-json]');
    if (!variantsScript) return;
    var variants = [];
    try {
      variants = JSON.parse(variantsScript.textContent);
    } catch (e) {
      variants = [];
    }

    var productUrl = root.getAttribute('data-product-url');
    var pills = root.querySelectorAll('[data-option-value]');
    if (!pills.length) return;

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        if (pill.classList.contains('is-selected')) return;
        var group = pill.closest('[data-option-index]');
        group.querySelectorAll('[data-option-value]').forEach(function (p) {
          p.classList.toggle('is-selected', p === pill);
        });

        var selections = [];
        root.querySelectorAll('[data-option-index]').forEach(function (g) {
          var active = g.querySelector('.is-selected');
          var index = Number(g.getAttribute('data-option-index'));
          selections[index] = active ? active.getAttribute('data-option-value') : null;
        });

        var matched = variants.find(function (v) {
          return [v.option1, v.option2, v.option3].every(function (opt, i) {
            return selections[i] == null || opt === selections[i];
          });
        });

        if (matched) updateForVariant(root, productUrl, matched);
      });
    });
  }

  function updateForVariant(root, productUrl, variant) {
    var infoContainer = root.querySelector('[data-product-info]');
    if (!infoContainer || !productUrl) return;

    var url = productUrl + '?variant=' + variant.id + '&section_id=main-product';

    if (history.replaceState) {
      var current = new URL(window.location.href);
      current.searchParams.set('variant', variant.id);
      history.replaceState({}, '', current.toString());
    }

    fetch(url)
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var freshInfo = doc.querySelector('[data-product-info]');
        if (freshInfo) {
          infoContainer.innerHTML = freshInfo.innerHTML;
          initVariantPicker(root);
        }
      })
      .catch(function () {
        /* fail silently — the form still submits the previously selected variant id */
      });

    if (variant.featured_media && variant.featured_media.id) {
      showMediaById(root, String(variant.featured_media.id));
    }
  }
})();
